/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_2Inputs */

const en_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top center`)
};

const fr_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre supérieur`)
};

const de_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben Mitte`)
};

const it_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto al centro`)
};

const ru_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верхний центр`)
};

const es_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

const zh_cn2_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶部中心`)
};

const ja_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央上部`)
};

const hi_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष केंद्र`)
};

const pt_pt2_live_caption_youtube_region_2 = /** @type {(inputs: Live_Caption_Youtube_Region_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

/**
* | output |
* | --- |
* | "Top center" |
*
* @param {Live_Caption_Youtube_Region_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_2 = /** @type {((inputs?: Live_Caption_Youtube_Region_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_2(inputs)
	if (locale === "de") return de_live_caption_youtube_region_2(inputs)
	if (locale === "it") return it_live_caption_youtube_region_2(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_2(inputs)
	if (locale === "es") return es_live_caption_youtube_region_2(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_2(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_2(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_2(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_2(inputs)
	return en_live_caption_youtube_region_2(inputs)
});